import React from "react";

const StatsSection = () => {
  const stats = [
    { number: "21+", label: "Projects Completed" },
    { number: "2+", label: "Years Experience" },
    { number: "50+", label: "Happy Clients" },
    { number: "24/7", label: "Tech Support Available" },
  ];

  return (
    <div className="py-12 sm:py-16 md:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="inline-block px-4 sm:px-5 py-1.5 sm:py-2 bg-blue-50 text-blue-500 rounded-md text-xs sm:text-sm font-semibold mb-6 sm:mb-8 tracking-wide">
          ABOUT POSTMINT
        </div>

        <div className="flex flex-col lg:flex-row gap-8 sm:gap-10 md:gap-12 lg:gap-20 items-start">
          {/* Left Content Section */}
          <div className="w-full lg:w-1/2">
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6 md:mb-8 leading-tight">
              Empowering Digital
              <br />
              Transformation
            </h2>
            <p className="text-base sm:text-lg text-gray-600 mb-4 sm:mb-5 md:mb-7 leading-relaxed">
              At Postmint, we believe in the transformative power of technology.
              Our mission is to provide innovative IT solutions that not only
              meet your current needs but also prepare you for future challenges
              and opportunities.
            </p>
            <p className="text-base sm:text-lg text-gray-600 mb-6 sm:mb-8 md:mb-10 leading-relaxed">
              With a team of experienced professionals and a commitment to
              excellence, we deliver results that exceed expectations and drive
              sustainable business growth.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 md:gap-10 text-sm sm:text-base text-gray-700">
              <div className="flex items-center gap-3">
                <div className="w-2.5 h-2.5 bg-blue-500 rounded-full flex-shrink-0"></div>
                <span className="font-medium">Innovation-Driven Approach</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-2.5 h-2.5 bg-blue-500 rounded-full flex-shrink-0"></div>
                <span className="font-medium">Client-Centric Solutions</span>
              </div>
            </div>
          </div>

          {/* Right Stats Section */}
          <div className="w-full lg:w-1/2 grid grid-cols-2 gap-4 sm:gap-5 md:gap-6 lg:gap-7">
            {stats.map((stat, index) => (
              <div
                key={index}
                className="bg-gray-50 rounded-xl sm:rounded-2xl p-6 sm:p-8 md:p-10 text-center shadow-sm"
              >
                <div className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-blue-500 mb-2 sm:mb-3 md:mb-4">
                  {stat.number}
                </div>
                <div className="text-sm sm:text-base md:text-lg text-gray-700 font-medium">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsSection;
